import {Component, HostListener, OnInit} from '@angular/core';
import {EventService} from "../../services/event.service";
import {PageService} from "../../services/page.service";
import {ChangeEventDialogComponent} from "../dialogs/change-event-dialog/change-event-dialog.component";
import {ChangeNationalTeamDialogComponent} from "../dialogs/change-national-team-dialog/change-national-team-dialog.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {UiStateService} from "../../services/ui-state.service";
import {PermissionService} from "../../services/permission.service";
import {NationalTeamsService} from '../../services/national-teams.service';
import {FundraisingViewService} from '../../services/fundraising-view.service';
import { HybridToolsService } from '../../services/hybrid-tools.service';

declare var $: any;
declare var ENVIRONMENT_CONFIG: any;

@Component({
    selector: 'cat-menu-left',
    templateUrl: './menu-left-vertical.component.html',
})
export class MenuLeftComponent implements OnInit {
    userPage: any;
    teamPage: any;
    nationalTeamPage: any;
    showTeamGuide = false;
    showTeamPageOptions = false;
    addressBookConnection: any;
    participantLabel: string;
    currentView: string;

    constructor(
        public eventService: EventService,
        public modalService: NgbModal,
        public pageService: PageService,
        public uiStateService: UiStateService,
        public permissionService: PermissionService,
        public nationalTeamsService: NationalTeamsService,
        public fundraisingViewService: FundraisingViewService,
        public hybridToolsService: HybridToolsService
    ) {
        this.eventService.onEventInit.subscribe(event => {
            this.initPageUrls(event, false);
            this.showTeamRelatedMenuItems();
            this.showCorrectLables();
            this.initAddressBook();
            this.currentView = this.fundraisingViewService.getCurrentView();
        });
        this.eventService.onEventChange.subscribe(event => {
            this.initPageUrls(event, true);
            this.showTeamRelatedMenuItems();
            this.showCorrectLables();
            this.initAddressBook();
            this.currentView = this.fundraisingViewService.getCurrentView();
        });
        this.nationalTeamsService.onNationalTeamInit.subscribe(nationalTeam => {
            this.initNationalSubTeams();
            this.initNationalTeamPageUrl(nationalTeam, true);
            this.currentView = this.fundraisingViewService.getCurrentView();
        });
        this.nationalTeamsService.onNationalTeamChange.subscribe(nationalTeam => {
            this.initNationalSubTeams();
            this.initNationalTeamPageUrl(nationalTeam, true);
            this.currentView = this.fundraisingViewService.getCurrentView();
        });
        this.fundraisingViewService.onViewInit.subscribe(nationalTeam => {
            this.currentView = this.fundraisingViewService.getCurrentView();
        });
    }

    openChangeEventModal() {
        this.hybridToolsService.removeMobileMenuClasses();
        if(this.currentView === 'events_view') {
            this.modalService.open(ChangeEventDialogComponent);
        } else if(this.currentView === 'national_teams_view'){
            this.modalService.open(ChangeNationalTeamDialogComponent);
        }
        window.scrollTo(0,0);
    }

    switchActionLabel() {
        if(this.currentView === 'events_view') {
            return "Switch Event";
        } else if(this.currentView === 'national_teams_view'){
            return "Switch Team";
        }
    }

    currentItemText() {
        if(this.currentView === 'events_view') {
            return "Current Event";
        } else if(this.currentView === 'national_teams_view'){
            return "Current Team";
        }
    }

    currentItemLabel() {
        if(this.currentView === 'events_view' && !!this.eventService.selectedEvent) {
            return this.eventService.selectedEvent.label;
        } else if(this.currentView === 'national_teams_view' && !!this.nationalTeamsService.selectedNationalTeam){
            return this.nationalTeamsService.selectedNationalTeam.name;
        }
    }

    currentItemDate() {
        if(this.currentView === 'events_view' && !!this.eventService.selectedEvent) {
            return this.eventService.selectedEvent.date;
        } else if(this.currentView === 'national_teams_view' && !!this.nationalTeamsService.selectedNationalTeam){
            return this.nationalTeamsService.selectedNationalTeam.calendarYear;
        }
    }

    currentItemLength() {
        if(this.currentView === 'events_view') {
            return this.eventService.numberOfEvents();
        } else if(this.currentView === 'national_teams_view'){
            return this.nationalTeamsService.numberOfNationalTeams();
        }
    }

    onEventSelect(event) {
        this.eventService.setEvent(event);
    }

    showTeamRelatedMenuItems() {
        this.showTeamGuide = false;
        this.showTeamPageOptions = false;
        if ((this.eventService.selectedEvent.gql.Participant[0].teamRoleType &&
            this.eventService.selectedEvent.gql.Participant[0].teamRoleType.name === 'CAPTAIN' &&
            this.eventService.selectedEvent.cssClass !== 'program-mwoy' &&
            this.eventService.selectedEvent.cssClass !== 'program-voy' &&
            this.eventService.selectedEvent.cssClass !== 'program-soy' &&
            this.eventService.selectedEvent.cssClass !== 'program-svoy') ||
            this.eventService.selectedEvent.cssClass === 'program-regatta') {
            this.showTeamGuide = true;
        }

        if ((this.eventService.selectedEvent.gql.Participant[0].teamRoleType &&
            this.eventService.selectedEvent.gql.Participant[0].teamRoleType.name === 'CAPTAIN' &&
            this.eventService.selectedEvent.cssClass !== 'program-mwoy' &&
            this.eventService.selectedEvent.cssClass !== 'program-voy' &&
            this.eventService.selectedEvent.cssClass !== 'program-soy'&&
            this.eventService.selectedEvent.cssClass !== 'program-svoy') ||
            (this.eventService.selectedEvent.cssClass === 'program-regatta' && this.eventService.selectedEvent.gql.Participant[0].team)) {
            this.showTeamPageOptions = true;
        }

        //Allow new SVOY events management of team page
        if (this.eventService.selectedEvent.cssClass === 'program-svoy' &&
            this.eventService.selectedEvent.gql.Participant[0].event.sysEventTypeName === 'C360_EVENT' &&
            this.eventService.selectedEvent.gql.Participant[0].teamRoleType) {

            let teamRoleTypeName = this.eventService.selectedEvent.gql.Participant[0].teamRoleType.name;
            if (teamRoleTypeName === 'CANDIDATE' || teamRoleTypeName === 'HONORED_CANDIDATE_F' || teamRoleTypeName === 'MWOY_ALL_STAR') {
                if (!!this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraiserPageId) {
                    this.showTeamPageOptions = true;
                }
            }
        }
    }


    canManageNationalTeamsAndEventsView() {
        return this.fundraisingViewService.canManageNationalTeamsAndEventsView();
    }


    isManageNationalTeamsViewVisible() {
        return this.fundraisingViewService.isManageNationalTeamsViewVisible();
    }

    isManageEventsViewVisible() {
        return this.fundraisingViewService.isManageEventsViewVisible();
    }

    showCorrectLables() {
        this.participantLabel = this.uiStateService.changeParticipantLabel(this.eventService.selectedEvent.cssClass);
    }

    initAddressBook() {
        this.addressBookConnection = this.eventService.selectedEvent.gql.Participant[0].individualConstituent.constituentAddressBooksConnection;
    }

    initPageUrls(event, forceReload) {
        this.teamPage = null;
        if (this.eventService.selectedEvent.gql.Participant[0].team) {
            this.pageService.getTeamPage(this.eventService.selectedEvent.participantId, this.eventService.selectedEvent.gql.Participant[0].team.teamId, forceReload)
                .subscribe(page => {
                    this.teamPage = page;
                }, err => {
                    this.teamPage = null;
                });
        }
        this.pageService.getUserPage(this.eventService.selectedEvent.participantId, forceReload)
            .subscribe(page => {
                this.userPage = page;
            }, err => {
                this.userPage = null;
            });
    }

    initNationalTeamPageUrl(nationalTeam, forceReload) {
        this.nationalTeamPage = null;
        if (this.nationalTeamsService.selectedNationalTeam) {
            this.pageService.getNationalTeamPage(this.nationalTeamsService.selectedNationalTeam.nationalTeamPageId, forceReload)
                .subscribe(page => {
                    this.nationalTeamPage = page;
                }, err => {
                    this.nationalTeamPage = null;
                });
        }
    }

    ngOnInit() {

        if (this.eventService.selectedEvent) {
            this.initPageUrls(this.eventService.selectedEvent, false);
            this.showTeamRelatedMenuItems();
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        // remove submenu toggle class when viewport back to full view
        if ($('body').hasClass('cat__config--horizontal') || $('body').width() > 991) {
            $('.cat__menu-left__submenu--toggled').removeClass('cat__menu-left__submenu--toggled').find('> .cat__menu-left__list').attr('style', '');
        }
    }

    menuToggle(event) {

        if ($('body').width() < 992) {
            if (this.hybridToolsService.hasMobileMenuClasses()) {
                this.hybridToolsService.removeMobileMenuClasses();
                this.hybridToolsService.conditionallyEnableBodyScrollOnMobile();
            } else {
                this.hybridToolsService.addMobileMenuClasses();
                this.hybridToolsService.conditionallyDisableBodyScrollOnMobile();
            }
        } else {
            $('body').toggleClass('cat__menu-left--visible');
        }
    }

    subMenuToggle(event) {

        if ($('body').hasClass('cat__config--vertical') || $('body').width() < 992) {

            var parent = $(event.target).parent();
            var opened = $('.cat__menu-left__submenu--toggled');

            if (!parent.hasClass('cat__menu-left__submenu--toggled') && !parent.parent().closest('.cat__menu-left__submenu').length)
                opened.removeClass('cat__menu-left__submenu--toggled').find('> .cat__menu-left__list').slideUp(200);

            parent.toggleClass('cat__menu-left__submenu--toggled');
            parent.find('> .cat__menu-left__list').slideToggle(200);

        }
    }

    backdropClick(event) {
        this.hybridToolsService.removeMobileMenuClasses();
        this.hybridToolsService.conditionallyEnableBodyScrollOnMobile();
    }

    changeCurrentView() {
        this.fundraisingViewService.switchToCurrentView(this.currentView);
    }

    closeMenu(event) {
        this.hybridToolsService.removeMobileMenuClasses();
        this.hybridToolsService.conditionallyEnableBodyScrollOnMobile();

        if ($(event.target).parent().hasClass('cat__menu-left__item') && $(event.target).parent().parent().hasClass('cat__menu-left__list--root')) {
            if ($('.cat__menu-left__submenu').hasClass('cat__menu-left__submenu--toggled')) {
                $('.cat__menu-left__submenu').removeClass('cat__menu-left__submenu--toggled');
                $('.cat__menu-left__submenu .cat__menu-left__list').slideUp(200);
            }
        }
    }

    get helpFullUrl() {
        let help_url = this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.fundraisingToolsHelpUrl;
        return ENVIRONMENT_CONFIG.fundraiseUrl + help_url;
    }

    private initNationalSubTeams() {
        this.nationalTeamsService.loadCurrentNationalTeamRelatedDataGql();
    }
}
